import ApiService from "@/core/services/api.service";
import { STATUS_CODE } from "@/core/config/constant";
import { SET_ERROR } from "@/core/services/store/auth.module";

const { AUTHENTICATE, ERROR_SERVER, SUCCESS, BAD_REQUEST } = STATUS_CODE;
// mutation types
export const ADD_BUSINESS = "addBusiness"
export const SET_STATUS = "SetStatus"
export const SET_ERROR_MESSAGE = "SetErrorMessage"

const state = {
  errors: null,
  status: null
}

const getters = {
  BusinessStatus: state => state.status,
  BusinessErrors: state => state.errors
}

const mutations = {
  [SET_STATUS](state, code) {
    state.status = code;
  },
  [SET_ERROR_MESSAGE](state, errors) {
    state.errors = errors
  }
}

const actions = {
  async [ADD_BUSINESS](context, dataInsert) {
    context.commit(SET_STATUS, null)
    context.commit(SET_ERROR_MESSAGE, null)
    try {
      const response = await ApiService.post('admin/business-manager/registration', dataInsert)
      if (response.data.code == SUCCESS) {
        context.commit(SET_STATUS, response.data.code)
      }

      if (response.data.code == BAD_REQUEST) {
        context.commit(SET_STATUS, response.data.code)
        context.commit(SET_ERROR_MESSAGE, response.data.data)
      }
    } catch (e) {
      if (e.response.data.code == ERROR_SERVER) {
        context.commit(SET_ERROR, e.response.data.message);
        throw e.response.data.message
      } else {
          throw e;
      }
    }
    
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}